import React, { Fragment } from 'react';
import Header from '@components/Header';
import { graphql } from 'gatsby';
import { css } from '@emotion/react';
import Footer from '@components/Footer';
import BackgroundImage from 'gatsby-background-image';
import PlanList from '@components/PlanList';

export default function PricingTemplate({
  data: {
    pricingBG,
    page: { planList/*, acf: { language }*/ }
  }, pageContext: { language, refs, layouts }
}) {
  return (
    <Fragment>
      <div>
        <Header
          dark
          language={language}
          refs={refs}
          layouts={layouts}
        />
      </div>
      <BackgroundImage fluid={pricingBG.sharp.fluid}>
        <div
          css={css`
            background: url("/pricing-bg.png");
          `}
        >
          <div className="container-fluid">
            <div
              className="d-flex align-items-center justify-content-center"
              css={css`
                padding: 100px 0 3rem 0;
              `}
            >
              <PlanList planList={planList} />
            </div>

            <div
              css={css`
                * {
                  margin: 0;
                }
                padding-bottom: 3rem;
                text-align: center;
                a {
                  color: white;
                }
              `}
              dangerouslySetInnerHTML={{
                __html: planList && planList.plan_negotiable_offer
              }}
            />
          </div>
        </div>
      </BackgroundImage>
      <Footer
        language={language}
        layouts={layouts}
      />
    </Fragment>
  );
}

export const query = graphql`
  query($pricingId: Int) {
    pricingBG: file(relativePath: { eq: "pricing-bg.png" }) {
      sharp: childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    page: wordpressWpCustompages(wordpress_id: { eq: $pricingId }) {
      id
      acf {
        language
      }
      planList: childWordPressAcfPlanListSection {
        id
        plan_negotiable_offer
        plans {
          link {
            link_style
            link_text
            link_url
          }
          plan_billing_cycle
          plan_currency
          plan_features {
            feature
          }
          plan_name
          plan_price
        }
      }
    }
  }
`;